import NavigationBar from "../../../navigation_components/NavigationBar";
import CustomerAdministratorSideBar from "../../../sidebar_components/CustomerAdministratorSideBar";
import "../../../../styles/workspace_styles/CustomerAdministratorStyles/Accounts/Account.css";
import Profile from "./Profile";
import { useContext, useState } from "react";
import Security from "./Security";
import BillingAccount from "./BillingAccount";
import BottomRightMessageBox from "../../UniversalComponents/BottomRightMessageBox";
import { AppContext } from "../../../AppProvider";

const Account = () =>{
    const {customerIotProfile} = useContext(AppContext);
    const [selectedAccountTab,setSelectedAccountTab] = useState('profile');
    return(
        <div className="customer-administrator-account-page">
            <NavigationBar/>
            <div className="customer-administrator-account-page-layout">
                <div style={{display: customerIotProfile?.defaultDashboardAlwaysFullScreen? 'none':'block'}}>
                    <CustomerAdministratorSideBar/>
                </div>
                <div className="customer-administrator-account-parent-container">
                    <div className="customer-administrator-account-container">
                        <div className="customer-administrator-account-navigation-bar">
                            <button className={selectedAccountTab === 'profile'? 'active':''}
                                onClick={() =>setSelectedAccountTab('profile')}>
                                <img src={`${process.env.PUBLIC_URL}/images/user-icon-blue.png`}/>
                                <p>Profile</p>
                            </button>
                            <button className={selectedAccountTab === 'security'? 'active':''}
                                onClick={() => setSelectedAccountTab('security')}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/security-config-icon.png`}
                                />
                                <p>Security</p>
                            </button>
                            <button className={selectedAccountTab === 'server-connections'? ' active':''}
                                onClick={() => setSelectedAccountTab('server-connections')}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/billing-account-icon.png`}
                                />
                                <p>Billing</p>
                            </button>
                        </div>
                        <div className="customer-administrator-account-body">
                            {selectedAccountTab === 'profile'? <Profile/>:
                            selectedAccountTab === 'security'? <Security/>:<BillingAccount/>}
                        </div>
                    </div>
                </div>
            </div>
            <BottomRightMessageBox/>
        </div>
    );
};
export default Account;